import React from "react"
import styled from "styled-components"
import ClipLoader from "react-spinners/dist/spinners/ClipLoader"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"

const spinnerSize = 100

const LoadingSpinnerContainer = styled.div`
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: ${spinnerSize}px;
  height: ${spinnerSize}px;
`

function DashboardLoadingSpinner({ theme }) {
  return (
    <LoadingSpinnerContainer>
      <ClipLoader loading color={theme.primaryColor} size={spinnerSize} />
    </LoadingSpinnerContainer>
  )
}

DashboardLoadingSpinner.propTypes = {
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(connect(mapStateToProps))(DashboardLoadingSpinner)



// WEBPACK FOOTER //
// ./src/components/DashboardLoadingSpinner.jsx